import { useQueryClient } from "@tanstack/react-query";
import { forwardRef } from "react";
import { Link } from "react-router-dom";

import { Workflow } from "../types";

import Canvas from "./Canvas";
import Container from "./Container";
import Sidebar from "./Sidebar";
import { WorkflowProvider } from "./workflow-context";

import { Button } from "@/components/ui/button";

interface LayoutProps extends Workflow {
  readonly?: boolean;
  embed?: boolean;
  userToken: string | null;
}

const WorkflowCanvas = forwardRef((props: LayoutProps, ref) => {
  const { readonly, embed } = props;
  const queryClient = useQueryClient();
  const version = props.nodes.length > 0 && props.nodes[0]?.workflow_version_id;
  const first_node_id = props.nodes.length > 0 && props.nodes[0]?.id;

  return (
    <WorkflowProvider
      ref={ref}
      workflow={{
        ...props,
        queryClient,
        nodes: props.nodes.map(node => ({ ...node, saved: true })),
      }}
      key={`${props.workflow_id}_${version}_${first_node_id}`}
    >
      <Container>
        {embed && (
          <div className="absolute right-4 top-4 z-50">
            <Button
              variant="default"
              className="transition-all hover:scale-105 hover:shadow-md"
              aria-label="Open workflow in full view"
              asChild
            >
              <Link to={`/workspace/${props.workspace_id}/workflow/${props.workflow_id}`}>
                Open Workflow <span className="ml-1 font-semibold">→</span>
              </Link>
            </Button>
          </div>
        )}
        <Canvas readonly={readonly} />
        <Sidebar readonly={readonly} />
      </Container>
    </WorkflowProvider>
  );
});

export default WorkflowCanvas;
